import { render } from "./PassengerProfile.vue?vue&type=template&id=0df47022"
import script from "./PassengerProfile.vue?vue&type=script&lang=js"
export * from "./PassengerProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__